import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AppBar, Box, Grid, Button, IconButton } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";

import useWindowSize from "../hooks/useWindowSize.js";
import { SearchBar } from "./SearchBar.jsx";
import { MlScaleReference } from "@mapcomponents/react-maplibre";
import MlCreatePdfButton from "./CreatePdfButton/MlCreatePdfButton.jsx";
import { AppContext } from "../context/AppContext.jsx";
import InfoIcon from "@mui/icons-material/Info";
import MenuIcon from "@mui/icons-material/Menu";
import ErrorMessageDisplay from "./ErrorMessageDisplay.jsx";
import GpsButton from "./GpsButton.jsx";

function Header() {
    const size = useWindowSize();
    const appContext = useContext(AppContext);
    const [menuOpen, setMenuOpen] = useState(false);
    const [searchError, setSearchError] = useState();

    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                color="default"
                sx={{
                    backgroundColor: "#fff",
                }}
            >
                <Toolbar sx={{ width: "100%", boxSizing: "border-box" }}>
                    <Grid
                        container
                        sx={{
                            justifyContent: "space-between",
                            width: "100%",
                            boxSizing: "border-box",
                            flexWrap: { md: "wrap", lg: "nowrap" },
                        }}
                    >
                        <Grid
                            key="logo"
                            size={{ xs: 5, sm: 2, md: 1 }}
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignContent: "center",
                                alignItems: "center",
                                padding: "4px 0",
                                flex: { md: "0 0 auto" },
                                width: { md: "auto" },
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                <a href="http://www.redcert.org" target="blank">
                                    <img
                                        src="assets/logo/REDcert.jpg"
                                        alt="RED cert logo"
                                        height="35"
                                        style={{ marginRight: "4px" }}
                                    />
                                </a>
                                <a
                                    href="https://sure-system.org"
                                    target="blank"
                                >
                                    <img
                                        src="assets/logo/SURE.jpg"
                                        alt="SURE logo"
                                        height="35"
                                    />
                                </a>
                            </Box>
                        </Grid>
                        {size.width > 900 && (
                            <Grid
                                key="search"
                                size={{ xs: 12, sm: 10, md: 9 }}
                                sx={{ minWidth: 0, flex: { md: "1 1 0%" } }}
                            >
                                <SearchBar setErrorMessage={setSearchError} />
                            </Grid>
                        )}
                        {size.width <= 1200 && (
                            <>
                                <Grid
                                    key="scale"
                                    size={{ xs: 7, sm: 5, md: 2 }}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "end",
                                        alignItems: "center",
                                        pr: { xs: 1, sm: 0 },
                                        flex: { md: "0 0 auto" },
                                        width: { md: "auto" },
                                        minWidth: 0,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            marginTop: "14px",
                                        }}
                                    >
                                        <MlScaleReference />
                                    </Box>

                                        <GpsButton mapId="map_1"/>

                                    <MlCreatePdfButton />
                                    
                                    <IconButton
                                        variant="contained"
                                        onClick={() => {
                                            setMenuOpen(!menuOpen);
                                        }}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                </Grid>
                            </>
                        )}
                        {size.width <= 1200 && menuOpen && (
                            <Grid
                                size={12}
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <IconButton
                                        color="primary"
                                        variant="contained"
                                        onClick={() => {
                                            appContext.setInfoDialogOpen(true);
                                        }}
                                    >
                                        <InfoIcon />
                                    </IconButton>

                                <Link to="/benutzerhandbuch">
                                    <Button>Handbuch</Button>
                                </Link>
                                <Link to="/impressum">
                                    <Button>Impressum</Button>
                                </Link>
                                <Link to="/Datenschutz">
                                    <Button>Datenschutz</Button>
                                </Link>
                            </Grid>
                        )}
                        {size.width <= 900 && (
                            <Grid
                                key="search"
                                size={{ xs: 12, sm: 8, md: 6 }}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                }}
                            >
                                <SearchBar setErrorMessage={setSearchError} />
                            </Grid>
                        )}
                        {size.width > 1200 && (
                            <>
                                <Grid
                                    key="scale"
                                    size={{ xs: 12, sm: 12, md: 2 }}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "end",
                                        alignItems: "center",
                                        flexBasis: "auto",
                                        flex: { md: "0 0 auto" },
                                        width: { md: "auto" },
                                        minWidth: 0,
                                    }}
                                >
                                    <MlScaleReference />
                                    <Button
                                        sx={{
                                            marginLeft: "8px",
                                        }}
                                        onClick={() => {
                                            appContext.setInfoDialogOpen(true);
                                        }}
                                    >
                                        <InfoIcon fontSize="large" />
                                    </Button>
                                    <Link to="/benutzerhandbuch">
                                        <Button>Benutzerhandbuch</Button>
                                    </Link>
                                    <Link to="/impressum">
                                        <Button>Impressum</Button>
                                    </Link>
                                    <Link to="/Datenschutz">
                                        <Button>Datenschutz</Button>
                                    </Link>
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Toolbar>
            </AppBar>

            {searchError && (
                <ErrorMessageDisplay
                    error={searchError}
                    setMessage={setSearchError}
                />
            )}
        </>
    );
}

export default Header;
